import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormButtonsComponent } from 'components/form-buttons/form-buttons.component';
import { InputComponent } from 'components/input/input.component';
import { ModalComponent } from 'components/modal/modal.component';
import { Modal, ModalActionType } from 'components/modal/modal.model';
import { CustomValidators } from 'weavix-shared/custom-validators';
import { AutoUnsubscribe } from 'weavix-shared/utils/utils';

@AutoUnsubscribe()
@Component({
    selector: 'app-table-rows-delete-modal',
    templateUrl: './table-rows-delete-modal.component.html',
    styleUrls: ['./table-rows-delete-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        FormButtonsComponent,
        InputComponent,
        ModalComponent,
    ],
})
export class TableRowsDeleteModalComponent implements OnChanges {
    @Input() open = false;
    @Input() type: string;
    @Input() count: number;
    /** Overrides the body wording, for tables whose rows do not simply leave "your account". */
    @Input() bodyKey?: string;
    @Input() bodyParams?: { [key: string]: unknown };
    @Output() closed = new EventEmitter<ModalActionType>();

    form: FormGroup<{ count: FormControl<string> }>;
    tableRowsDeleteModal: Modal;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.open?.currentValue) {
            this.modalOpen();
        } else {
            this.modalClose();
        }
    }

    async modalOpen() {
        this.form = new FormGroup({
            count: new FormControl('', [Validators.required, CustomValidators.stringMatch(this.count?.toString())]),
        });

        this.tableRowsDeleteModal = {
            isOpen: true,
            actions: {},
            header: {
                textKey: 'table.delete-confirmation.title',
                showSeparator: true,
                textAlignment: 'left',
            },
            params: {
                type: this.type,
                count: this.count?.toString(),
                ...this.bodyParams,
            },
            fullScreen: false,
            content: true,
            width: 600,
        };
    }

    async submit() {
        this.closed.next(ModalActionType.submit);
    }

    async cancel() {
        this.closed.next(ModalActionType.cancel);
    }

    async handleModalClose(action: ModalActionType) {
        this.closed.next(action);
    }

    modalClose() {
        this.tableRowsDeleteModal = null;
        this.closed.emit();
    }
}
